import React, { useEffect, useState } from "react";
import { Swiper } from "swiper/react";

import classNames from "classnames/bind";
import "./StoriesSubSlider.scss";
import storiesStyles from "./StoriesSubSlider.module.scss";
import { useStoriesProviderData } from "../../../providers/storiesProvider";
import { SlideVideoType } from "./SlideVideoType";
import { SlideImageType } from "./SlideImageType";
import { Pagination } from "swiper/modules";
import { SwiperOptions } from "swiper/types/swiper-options";
import { Swiper as SwiperClass } from "swiper/types";
import { StoriesLoader } from "../StoriesLoader/StoriesLoader";
import { StorySlide } from "@core/types";

const cx = classNames.bind(storiesStyles);

interface IStoriesSubSlider {
  subIndex: number;
  slides: StorySlide[];
}

const paginationConf: SwiperOptions["pagination"] = {
  el: `.pagination`,
  bulletClass: "pagination-bullet",
  bulletActiveClass: "pagination-bullet-active",
  clickable: false,
  renderBullet: () => {
    return `<span class="pagination-bullet"><span class="pagination-bullet__progress"></span></span>`;
  },
};

const storiesSliderConf = {
  navigation: false,
  lazyPreloadPrevNext: 1,
  pagination: paginationConf,
  modules: [Pagination],
  speed: 1,
  loop: false,
  allowTouchMove: false,
};

const StoriesSubSlider = ({ subIndex, slides }: IStoriesSubSlider) => {
  const { setNestedSlider, parentSliderActiveIndex, setIsSliderPlaying, isSliderLoading } = useStoriesProviderData();

  const [swiper, setSwiper] = useState<SwiperClass | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!!swiper && parentSliderActiveIndex === subIndex) {
      setNestedSlider(swiper, subIndex);
    }
  }, [parentSliderActiveIndex, subIndex, swiper]);

  return (
    <Swiper
      onInit={(swiper: SwiperClass) => {
        setIsSliderPlaying(false);
        setSwiper(swiper);
      }}
      onSlideChange={() => {
        if (swiper) {
          setActiveIndex(swiper.activeIndex);
          setIsSliderPlaying(false);
        }
      }}
      autoplay={false}
      className={`slider ${cx("slider")}`}
      {...storiesSliderConf}
    >
      {isSliderLoading && <StoriesLoader />}
      <div className={`pagination`}>
        <div className={cx("pagination__shadow")}></div>
      </div>
      {!!swiper &&
        slides.map(({ id, type, src, button }, i) => {
          const isActive = i === activeIndex && parentSliderActiveIndex === subIndex;
          return type === "image" ? (
            <SlideImageType key={id} buttonSlot={button} src={src} swiper={swiper} isActive={isActive} />
          ) : (
            <SlideVideoType key={id} buttonSlot={button} id={id} src={src} swiper={swiper} isActive={isActive} />
          );
        })}
    </Swiper>
  );
};

export { StoriesSubSlider };
